enum ModuleEnum {
  AccountingIntegrations = 'Accounting Integrations',
  AccountManagement = 'Dedicated Account Management',
  AiClinicalNotes = 'AI Clinical Notes',
  VirtualReception = 'Virtual Reception',
  AiScribes = 'AI Scribes',
  ApiAccess = 'API Access',
  AppointmentBilling = 'Quickbill',
  AppointmentRecall = 'Appointment Recall',
  Audit = 'Audit',
  BillingEntities = 'Billing Entities',
  Cemplicity = 'Cemplicity',
  Checklists = 'Checklists',
  Classes = 'Classes',
  ClinicalServices = 'Clinical Services',
  CloudRx = 'CloudRx',
  Commission = 'Commission feature',
  CommunicationBasic = 'Communication (Basic)',
  Communications = 'Communications',
  ConnectHideFromExplorer = 'Connect Hide From Explorer',
  ConnectInsurance = 'Connect for Insurance',
  ContactsAdvanced = '{Group} & Contact Management',
  ContactsBasic = '{Customer} Management',
  CreditBasedPackages = 'Credit Based Packages',
  CrmIntegration = 'CRM Integration',
  Tyro = 'Tyro',
  DxDashboards = 'DX Dashboards',
  UserDiaryRestriction = 'User Diary Restriction',
  PreReferralInformation = 'Pre-referral Information',
  StripeTerminals = 'Stripe Terminals',
  Caseflow = 'Caseflow',
  GPLookup = 'GP Lookup',
  StockLevels = 'Stock Levels',
  CardPayments = 'Card Payments',
  Treatments = 'Treatments',
  PatientPortal = 'Patient Portal',
  CRM = 'CRM',
  CRMBasic = 'CRM (Basic)',
  CRMAdvanced = 'CRM (Advanced)',
  Dashboard = 'Dashboard',
  DataWarehousing = 'Data Warehousing',
  DiaryAdvanced = 'Advanced Diary Management',
  DiaryBasic = 'Diary Management',
  DiaryEnhanced = 'Full Diary Management',
  DiarySkills = 'Diary Skills',
  DigitalPrescriptions = 'Digital Prescriptions',
  Embeddable = 'Embeddable Analytics',
  Equipment = 'Equipment',
  ExerciseIntegrations = 'Exercise Integrations',
  FinanceAdvanced = 'Advanced Financial Management',
  FinanceBasic = 'Financial Management',
  Forms = 'Forms',
  GarageServices = 'Garage Services',
  Healthcode = 'Healthcode Integration',
  IpRestriction = 'IP Restrictions',
  Journeys = 'Journeys',
  MedicalImaging = 'Medical Imaging',
  MultipleChargeAppointments = 'Multiple Charge Appointments',
  MultiLocation = 'Multi Location',
  MyAccount = 'My Account Section',
  MyAccountContacts = 'My Account Contacts',
  MyAccountInvoices = 'My Account Invoice',
  MyAccountSubscription = 'My Account Subscription Section',
  OnlineBookingsAdvanced = 'Booking Configuration',
  OnlineBookingsBasic = 'Online Bookings',
  Packages = 'Packages and Subscriptions',
  PathologyLabs = 'Pathology labs',
  PayPerClick = 'Pay Per Click',
  Pharmacierge = 'Pharmacierge',
  PostcodeLookup = 'Address Lookup',
  ProntoReferrals = 'Pronto Referrals',
  QuickStartWizard = 'QuickStartWizard',
  ReportingAdvanced = 'Reporting (Advanced)',
  ReportingBasic = 'Reporting',
  ReferralPortal = 'Referral Portal',
  ReferralPortalAdvanced = 'Referral Portal (Advanced)',
  ReportsBespoke = 'Bespoke Reports',
  RichTextMessages = 'Rich Text Messages',
  RoleManager = 'Role Manager',
  SecurityBasic = 'Security (Basic)',
  SecurityAdvanced = 'Security (Advanced)',
  SecurityEnhanced = 'Security (Enhanced)',
  SecureDocumentSharing = 'SecureDocumentSharing',
  SettingsBasic = 'Settings (Basic)',
  SettingsAdvanced = 'Settings (Advanced)',
  SMSBundles = 'SMS Bundles',
  SocialSignOn = 'Social Sign On',
  StockBasic = 'Stock (Basic)',
  StockAdvanced = 'Stock (Advanced)',
  SystemCredits = 'System Credits',
  Tasks = 'Tasks',
  TaxExemption = 'Tax Exemption',
  TechnicalSupport = 'Technical Support',
  TechnicalSupportAdvanced = 'Prioritised Technical Support',
  Teams = 'Teams',
  Telehealth = 'Telehealth',
  TreatmentAuthorisation = 'Treatment Authorisation'
}
export default ModuleEnum;
